import { ReactComponent as PhoneIcon } from "assets/icons/call.svg";
import PhoneButton from "../PhoneButton";

import * as S from "./ContactMenu.style";

const ContactMenu = ({ messagePhone }) => {
  return (
    <S.Content>
      <S.Section>
        <PhoneButton
          icon={<PhoneIcon />}
          number="0800 272 2021"
          subtitle={messagePhone}
        />
      </S.Section>
    </S.Content>
  );
};

export default ContactMenu;
